// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__yOG9Q","title":"AfterBackImages_title__3Zgm7","images":"AfterBackImages_images__28b7b"};